// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".v-toolbar .v-btn[data-v-cfdf131a]:not(.v-btn--depressed):not(.v-btn--flat) {\n  will-change: box-shadow;\n  -webkit-box-shadow: 0 3px 1px -2px rgba(0, 0, 0, 0.2), 0 2px 2px 0 rgba(0, 0, 0, 0.14), 0 1px 5px 0 rgba(0, 0, 0, 0.12);\n          box-shadow: 0 3px 1px -2px rgba(0, 0, 0, 0.2), 0 2px 2px 0 rgba(0, 0, 0, 0.14), 0 1px 5px 0 rgba(0, 0, 0, 0.12);\n}\n.apps_and_users_buttons .v-btn[data-v-cfdf131a] {\n  max-width: 8.5rem;\n  max-height: 2.5rem;\n}\n", ""]);
// Exports
module.exports = exports;
